import React from 'react';
import { SignUpProvider } from '../contexts/sign-up-context';
import PublicRoute from '../screens/auth/components/route';
import { OccupationKeyEnum } from '../screens/auth/intro/types';
import { renderRoutesFromArray } from './renderRoutesFromArray';

const Auth = React.lazy(() => import('../screens/auth/main'));
const LegacySignUp = React.lazy(() => import('../screens/auth/sign-up'));
const SpecialistBaselineSignUp = React.lazy(
  () => import('../screens/auth/sign-up/specialist-baseline')
);
const LogIn = React.lazy(() => import('../screens/auth/sign-in'));
const Forgot = React.lazy(() => import('../screens/auth/forgot-password/forgot'));
const Forgoted = React.lazy(() => import('../screens/auth/forgot-password/forgoted'));
const Reseted = React.lazy(() => import('../screens/auth/forgot-password/reseted'));
const Reset = React.lazy(() => import('../screens/auth/forgot-password/reset'));
const Unsubscribe = React.lazy(() => import('../screens/auth/unsubscribe'));
const ComfirmEmail = React.lazy(() => import('../screens/auth/sign-up/confirm-email'));
const AsyncConfirmRegistration = React.lazy(() => import('../screens/auth/confirm-registration'));
const AsyncConfirmRegistrationDoctorsEntry = React.lazy(
  () => import('../screens/auth/confirm-registration/doctors-entry')
);
const SubscribedToNews = React.lazy(() => import('../screens/auth/subscribed'));
const Imprint = React.lazy(() => import('../screens/main/policy/imprint'));
const Dataprotection = React.lazy(() => import('../screens/main/policy/dataprotection'));
const AGB = React.lazy(() => import('../screens/main/policy/agb'));

const routeDefinitions = [
  { path: '/confirm-registration/', element: <AsyncConfirmRegistration /> },
  {
    path: '/confirm-registration-doctors/',
    element: <AsyncConfirmRegistrationDoctorsEntry />,
  },
  {
    path: '/confirm-registration-students/',
    element: <AsyncConfirmRegistration />,
  },

  { path: '/sign-up-confirm-email', element: <ComfirmEmail /> },
  { path: '/sign-up-confirm-email-doctors', element: <ComfirmEmail /> },
  { path: '/sign-up-confirm-email-students', element: <ComfirmEmail /> },

  {
    path: '/auth-for-doctors',
    element: <Auth occupationKey={OccupationKeyEnum.SPECIALIST} />,
  },
  {
    path: '/auth-for-students',
    element: <Auth occupationKey={OccupationKeyEnum.STUDENT} />,
  },
  {
    path: '/auth-other-professions',
    element: <Auth occupationKey={OccupationKeyEnum.OTHER_PROFESSIONS} />,
  },
  {
    path: '/auth',
    element: <Auth occupationKey={OccupationKeyEnum.DEFAULT} />,
  },
  {
    path: '/auth-legacy',
    element: <Auth occupationKey={OccupationKeyEnum.DEFAULT} legacyMode />,
  },

  {
    path: '/sign-up',
    element: <SpecialistBaselineSignUp />,
  },
  {
    path: '/sign-up-legacy',
    element: (
      <SignUpProvider>
        <LegacySignUp />
      </SignUpProvider>
    ),
  },
  {
    path: '/sign-in',
    element: (
      <PublicRoute title="page-header.sign-in-with">
        <LogIn />
      </PublicRoute>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <PublicRoute title="page-header.forgot-password.title">
        <Forgot />
      </PublicRoute>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <PublicRoute title="page-header.reset.title">
        <Reset />
      </PublicRoute>
    ),
  },
  {
    path: '/reset-password/completed',
    element: (
      <PublicRoute title="page-header.reseted.title">
        <Reseted />
      </PublicRoute>
    ),
  },
  {
    path: '/forgot-password/completed',
    element: (
      <PublicRoute title="page-header.forgoted.title">
        <Forgoted />
      </PublicRoute>
    ),
  },
  {
    path: '/unsubscribe',
    element: (
      <PublicRoute title="unsubscribe.title">
        <Unsubscribe />
      </PublicRoute>
    ),
  },
  {
    path: '/subscribed-to-news',
    element: (
      <PublicRoute title="">
        <SubscribedToNews />
      </PublicRoute>
    ),
  },
  {
    path: '/privacy-imprint',
    element: (
      <PublicRoute title="Imprint">
        <Imprint />
      </PublicRoute>
    ),
  },
  {
    path: '/privacy-agb',
    element: (
      <PublicRoute title="AGB">
        <AGB />
      </PublicRoute>
    ),
  },
  {
    path: '/privacy-dataprotection',
    element: (
      <PublicRoute title="Data protection">
        <Dataprotection />
      </PublicRoute>
    ),
  },
];

const authRoutes = renderRoutesFromArray(routeDefinitions);
export default authRoutes;
